const getScrollPosition = (rootState) => rootState.ws.view.scrollPosition;

export default getScrollPosition;
